/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import { hiveContract, v2Contract } from "config";
import { useContractRead } from "wagmi";
import { BigNumber } from "ethers";

const useHiveBalanceInTokens = (
  tokenIds?: number[]
): [
  balanceInTokens: Record<number, BigNumber> | undefined,
  balanceInTokensSum: BigNumber | undefined,
  readBalanceInTokens: () => void
] => {
  const [balanceInTokens, setBalance] = useState<Record<number, BigNumber>>();
  const balanceInTokensSum = useMemo(
    () =>
      balanceInTokens
        ? Object.values(balanceInTokens).reduce(
            (sum, val) => sum.add(val),
            BigNumber.from("0")
          )
        : undefined,
    [balanceInTokens]
  );

  const args = useMemo(() => {
    if (!tokenIds) {
      return undefined;
    }

    return [v2Contract.address, tokenIds];
  }, [tokenIds]);

  const [{ data: balanceInTokensData }, readBalanceInTokens] = useContractRead(
    {
      addressOrName: hiveContract.address,
      contractInterface: hiveContract.interface,
    },
    "getBalanceByTokenIdsOfCollection",
    {
      args,
      skip: true,
    }
  );

  useEffect(() => {
    if (args) {
      readBalanceInTokens();
    }
  }, [args]);

  useEffect(() => {
    if (tokenIds && balanceInTokensData !== undefined) {
      const data = balanceInTokensData as [BigNumber[], BigNumber[]];

      setBalance(
        tokenIds.reduce(
          (prev, tokenId, i) => ({
            ...prev,
            [tokenId]: data[i],
          }),
          {}
        ) as Record<number, BigNumber>
      );
    }
  }, [tokenIds, balanceInTokensData]);

  return [balanceInTokens, balanceInTokensSum, readBalanceInTokens];
};

export default useHiveBalanceInTokens;
